import moneyMask from './moneyMask';

export default function getNumberValue(value = '00,00'): number {
  return parseFloat(
    moneyMask(value)
      .toString()
      .replaceAll('R$', '')
      .replaceAll(' ', '')
      .replaceAll('.', '')
      .replaceAll(',', '.'),
  );
}
